module.exports = __webpack_public_path__ + "img/1440.ce678677.jpg";